import { Resolver, transformToNestObject } from 'react-hook-form';
import * as Yup from 'yup';

export const parseErrorSchema = (
  error: Yup.ValidationError,
  validateAllFieldCriteria: boolean,
) =>
  Array.isArray(error.inner) && error.inner.length
    ? error.inner.reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (previous: Record<string, any>, { path, message, type }) => {
          const previousTypes = (previous[path] && previous[path].types) || {};
          // console.log('previous: ', previous);
          return {
            ...previous,
            ...(path
              ? {
                  [path]: {
                    ...(previous[path] || {
                      message,
                      type,
                    }),
                    ...(validateAllFieldCriteria
                      ? {
                          types: {
                            ...previousTypes,
                            [type]: previousTypes[type]
                              ? [...[].concat(previousTypes[type]), message]
                              : message,
                          },
                        }
                      : {}),
                  },
                }
              : {}),
          };
        },
        {},
      )
    : {
        [error.path]: { message: error.message, type: error.type },
      };

export const yupResolver =
  <TFieldValues extends Record<string, unknown>>(
    schema: Yup.ObjectSchema | Yup.Lazy,
    options: Omit<Yup.ValidateOptions, 'context'> = {
      abortEarly: false,
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorsInterceptor: (errors: any) => any = (t: any) => t,
    onValid: (values: TFieldValues) => TFieldValues,
  ): Resolver<TFieldValues> =>
  async (values, context, validateAllFieldCriteria = false) => {
    try {
      // console.log('Received Values: ', values);
      if (
        (options as Yup.ValidateOptions).context &&
        import.meta.env.MODE === 'development'
      ) {
        console.warn(
          "You should not used the yup options context. Please, use the 'useForm' context object instead",
        );
      }
      const validatedValues = onValid(
        await schema.validate(values, {
          ...options,
          context,
        }),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ) as any;
      // console.log('Validated');
      return {
        values: validatedValues,
        errors: {},
      };
    } catch (e) {
      const parsedErrors = parseErrorSchema(e, validateAllFieldCriteria);
      // console.log('Actual Error: ', e);
      // console.log('parsedErrors: ', parsedErrors);
      // console.log(
      //   'transformToNestObject: ',
      //   transformToNestObject(errorsInterceptor(parsedErrors)),
      // );
      return {
        values: {},
        errors: validateAllFieldCriteria
          ? parsedErrors
          : transformToNestObject(errorsInterceptor(parsedErrors)),
      };
    }
  };
